import { DOMAIN_PORTAL_URL, DOMAIN_GUIDE_URL, domainPortalEnabled } from '../../../shared/domain-portal.mjs';

/** Keep the original domain component unmounted until the member explicitly
 * chooses legacy tools. Opening the portal panel must not run its store hooks. */
export function createDomainPortalPanel(LegacyDomains) {
  if (!LegacyDomains) return LegacyDomains;
  return {
    name: 'GrooveDomainPortalPanel',
    // Preserve the legacy component's original $parent / $children contract.
    abstract: true,
    components: { LegacyDomains },
    data() {
      return { portalEnabled: domainPortalEnabled(), showLegacyDomains: false };
    },
    render(h) {
      if (!this.portalEnabled) return h(LegacyDomains);
      const openLegacy = h('button', {
        class: 'gs-button gs-button--secondary px-4 py-2',
        attrs: { type: 'button' },
        on: { click: () => { this.showLegacyDomains = !this.showLegacyDomains; } },
      }, this.showLegacyDomains ? 'Back to ScalePlus domains' : 'Open legacy Groove domain tools');
      if (this.showLegacyDomains) return h('section', [openLegacy, h(LegacyDomains)]);
      return h('section', { class: 'p-4', attrs: { 'aria-label': 'Domains in ScalePlus' } }, [
        h('h2', { class: 'text-xl font-semibold mb-3' }, 'Manage domains in ScalePlus'),
        h('p', { class: 'mb-4' }, 'Manage supported Groove and Scale connections from one domain dashboard. Your existing websites and DNS records stay in place when you open it.'),
        h('a', { class: 'gs-button gs-button--primary inline-flex px-5 py-3 mb-4', attrs: { href: DOMAIN_PORTAL_URL } }, 'Open ScalePlus Domains'),
        h('details', { class: 'mb-4' }, [
          h('summary', { class: 'font-semibold cursor-pointer' }, 'Domain setup guide'),
          h('ol', { class: 'list-decimal pl-5 mt-3' }, [
            h('li', 'Sign in with your existing Groove account. The portal checks which domains and app resources belong to you.'),
            h('li', 'Choose a separate hostname for each app. For example, use example.com and www.example.com for PageBuilder, and blog.example.com for GrooveBlog.'),
            h('li', 'Keep your existing DNS manager and nameservers. If you use your own Cloudflare account, copy the ownership TXT record and the exact CNAME names and targets shown for that connection. Preserve email records and unrelated websites.'),
            h('li', 'Follow the selected app’s proxy and HTTPS instructions. Connect first, confirm the saved result, then intentionally change website routing and publish in the original app. Opening this dashboard does not publish private drafts.'),
            h('li', 'Check the exact public HTTPS address after DNS and publication are ready. For an uncertain operation, check its saved result before trying again.'),
          ]),
          h('a', { class: 'underline inline-block mt-3', attrs: { href: DOMAIN_GUIDE_URL } }, 'Open the full domain User Guide'),
        ]),
        h('p', { class: 'mb-4' }, 'GrooveKart, Groove AI, Blog folders, existing GroovePages hosted subdomains and legacy assignments that have not been associated with their content keep their original tools. Sending-domain and email verification also remain in their app.'),
        openLegacy,
      ]);
    },
  };
}
